import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ApiConnectorService } from '../../_LOGIC/__api/api-connector.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FunctionsService } from '../../_LOGIC/__common/functions.service';
import { BookingService } from '../../_LOGIC/booking.service';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { VerificationModalComponent } from '../verification-modal/verification-modal.component';
import { ResolverService } from 'src/app/_LOGIC/__common/resolver.service';
import { filter } from 'rxjs/operators';

export interface DialogData {
  records: [];
  clientCard: string;
}

@Component({
  selector: 'app-client-budget',
  templateUrl: './client-budget.component.html',
  styleUrls: ['./client-budget.component.css']
})
export class ClientBudgetComponent implements AfterViewInit {

  @ViewChild('budget') budget: ElementRef<HTMLDivElement>;
  @ViewChild('other') other: ElementRef<HTMLDivElement>;
  @ViewChild('packsoffer') packsoffer: ElementRef<HTMLDivElement>;
  @ViewChild('ourteam') ourteam: ElementRef<HTMLDivElement>;
  
  data = {
    packagesAsProductList: []
  }

  packages = [

    {
      name: 'Basic',
      description: 'Servicios necesarios para cubrir el proceso de salir de tu país. Te explicaremos los procesos y te brindaremos la información que necesitas.',
      css: 'basic',
      shortPrhase: 'Lo esencial para DIY',
      icon: 'fas fa-concierge-bell'
    },
    {
      name: 'Premium',
      description: 'Estaremos a tu lado durante todo el proceso, te iremos guiando paso a paso según prioridad para que vayas cumpliento cada fase del proceso de salir de tu país de origen hasta llegar a la ciudad destino.',
      css: 'premium',
      icon: 'fas fa-medal'
    },
    {
      name: 'Full Asssistance',
      description: 'Seremos tu asistente virtual 24/7 y estaremos pendientes de tu caso durante todo el procceso, mediante diferentes vías de comunicación nos encargaremos de facilitar al máximo todo el proceso para que tu único objetivo sea disfrutar de la experiencia.',
      css: 'full',
      icon: 'fas fa-user-tie'
    },

  ];

  dialogRef;
  packs = [];
  products = [];
  budgetId;

  otherProducts = [
    {
      product: 'Videollamada 60 minutos',
      icon: 'fas fa-user',
      discount: '25%',
      price: '39',
      oldPrice: null,
      actionButton: 'Reservar',
      css: 'videocall'
    },
    {
      product: 'Guía para elección de Universidad',
      icon: 'fas fa-university',
      discount: '25%',
      price: '69',
      oldPrice: null,
      actionButton: 'Contratar',
      css: 'university'
    },
    {
      product: 'Guía para encontrar apartamento',
      icon: 'fas fa-university',
      discount: '25%',
      price: '69',
      oldPrice: null,
      actionButton: 'Contratar',
      css: 'apartment'
    }
  ];

  clientDetails = {
    name: null,
    lastname: null,
    email: null,
    destination: null,
    dateFrom: null,
    goal: null,
    university: null,
    uePassport: null,
    validPassport: null,
    startLessons: null,
    firstContactDate: null,
    stayworking: null
  }
  

  constructor(private apiConnector: ApiConnectorService,private route: ActivatedRoute,private router: Router,private bookingService: BookingService,public dialog: MatDialog,private commonFunctions: FunctionsService,private resolver: ResolverService) {
    this.budgetId = this.route.snapshot.paramMap.get('token')
    this.budgetId? this.budgetId :this.budgetId = null;
    this.bookingService.saveToken(this.budgetId);
    this.getOrder();
    this.openDefaultConfirmationModal(null);
  }

/*   ngOnInit(): void {

  } */

  getShoppingCart(){
    return this.bookingService.getCartItems();
  }

  openDefaultConfirmationModal(obj): void {
    obj? obj : obj = { message: '', button1: 'Ok'}
    this.dialogRef = this.dialog.open(VerificationModalComponent, {
      data: obj,
    });
    return this.dialogRef;
  }

  getDateFrom(){
    if(this.clientDetails.dateFrom &&  this.clientDetails.dateFrom != '0000-00-00'){
      return this.commonFunctions.getShortDate(this.clientDetails.dateFrom);
    }else{
      return null;
    }
  }

  getProducts(){
    this.apiConnector.simpleQueryId('get','product',null,null,null,null).subscribe(
      (response) => {
        this.processGetProducts(response);
      },
      (error) => {
        debugger
        /* this.guiFlow.reportError(error,'onboarding-page'); */
      }
    );
  }

  isLocked(){
    return this.bookingService.isLocked();
  }

  getOrder(){
    this.apiConnector.simpleQueryId('get','clientOrder',null,null,null,null).subscribe(
      (response) => {
        this.processOrder(response);
      },
      (error) => {
        debugger
        /* this.guiFlow.reportError(error,'onboarding-page'); */
      }
    );
  }

  processCotizacion(res){
    if(res && res.records){
      if(res.records[0]){
        res.records[0].name? this.clientDetails.name = res.records[0].name: null;
        res.records[0].lastname? this.clientDetails.lastname = res.records[0].lastname: null;
        res.records[0].destination? this.clientDetails.destination = res.records[0].destination: null;
        res.records[0].dateFrom? this.clientDetails.dateFrom = res.records[0].dateFrom: null;
        res.records[0].university? this.clientDetails.university = res.records[0].university: null;
        res.records[0].goal? this.clientDetails.goal = res.records[0].goal: null;
      }
    }
  }

  processOrder(r){
  
  }

  /* SELECT pack.package_type,pack.name,prod.description,prod.category,pack.price 
  FROM `package` AS pack INNER JOIN `productXpackage` AS prodPack ON pack.id = prodPack.FK_ID_package INNER JOIN `product` AS prod ON prod.id = prodPack.FK_ID_product WHERE pack.id = '1'

   */

  getPacksInfo(){
    this.apiConnector.simpleQueryId('getPacksInfo','',null,null,null,null).subscribe(
      (response) => {
        this.abc(response);
      },
      (error) => {
        debugger
        /* this.guiFlow.reportError(error,'onboarding-page'); */
      }
    );
  }

  abc(a){
    debugger
  }

  getClientPackages(){
    if(this.resolver.getDependency('getCotizacion') && this.resolver.getDependency('getCotizacion').records){
      return this.resolver.getDependency('getCotizacion').records[0].data;
    }else{
      return [];
    }
  }

  ngAfterViewInit() {
    // Optional: If you want to scroll immediately when the view initializes, you can call this.scrollToElement() here
  }

  scrollToElement(label): void {

    switch(label){
      case 'budget':
        this.budget.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'other':
        this.other.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'packsoffer':
        this.packsoffer.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'ourteam':
        this.ourteam.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
    }

    
  }

  processGetProducts(res){
    if(res && res.records){
        /* this.properties = res.props; */
      this.products = res.records;
    }else{
      this.products = [];
    }
  }

  getCurrentPack(){
    return null;
  }

  bookNow(product){
    let newBooking = {
      price: product.price,
      clientDetails: this.clientDetails,
      products: [
        product
      ]
    }
    //this.bookingService.selectBooked(newBooking);
    this.router.navigateByUrl('book');
  }

  getClientData(){
    this.processCotizacion(this.resolver.getDependency('getCotizacion'));
    return this.clientDetails;
  }

  /* CSS */

  getCssClass(pack){
    return 'destination-item backimage-'+pack.css;
  }

  getCssClassImage(product){
    return 'offer-item backimage-'+product.css;
  }

  getBannerCss(){
    let css = 'inner-baner-container back-image';
    switch(this.clientDetails['destination']){
      case 'Madrid':
      case 'madrid':
        return css+'-madrid';
      case 'Barcelona':
      case 'barcelona':
          return css+'-barcelona';
      default:
        return css+'-other';
    }
  }

}

